const locationTypes = {
  Escuela: 135,
  OficinaProveedor: 136,
  CSEE: 137,
  Hogar: 482,
};

export default locationTypes;
